/* eslint-disable */

import gsap from "gsap";

function CountDownTimer() {
  /*
  ** How to use:
  *** Create a parent element
  *** set id="timer"
  *** set data-hours for the hours counter
  *** set data-minutes for the hours counter
  *** set data-seconds for the hours counter
  **** note
  ** if you dont set data-hours, data-minutes, data-seconds by default these set value 0
  ** if you dont set data-timer-end by default it's set timer-end
  ** Link: https://codepen.io/MohssineAboutajWeb/pen/PyBwXY
  */

  const oneSec = 1000,
  // const oneSec = 999,
  container = document.getElementById('timer');
  let containerWrap = document.querySelector('.timer-group');
  let timerBg = document.querySelector('.timer-group .timer-background');

  let tl = gsap.timeline({repeat: -1});
  let t2 = gsap.timeline({repeat: -1});


  tl.to(timerBg, {
    duration: 1,
    backgroundColor: '#F3DDDF',
    ease: "power1.Out",
  })
  tl.to(timerBg, {
    duration: 1,
    backgroundColor: '#AFD4FF',
    ease: "power1.Out",
  })
  tl.to(timerBg, {
    duration: 1,
    backgroundColor: '#C7BCD6',
    ease: "power1.Out",
  })
  tl.to(timerBg, {
    duration: 1,
    backgroundColor: '#FFF6CA',
    ease: "power1.Out",
  })


  t2.to(timerBg, {
    duration: 0.5,
    ease: "power1.Out",
    scale: 1.1,
  })
  t2.to(timerBg, {
    duration: 0.5,
    ease: "power1.Out",
    scale: 1,
  })


  // let dataHours = container.getAttribute('data-hours'),
  let dataMinutes = container.getAttribute('data-minutes'),
  dataSeconds = container.getAttribute('data-seconds'),
  // timerEnd = container.getAttribute('data-timer-end'),
  timerEnd = '',
  timerOnEndMsg = "data-timer-end";

  // if (dataHours == '' || dataHours == null || dataHours == NaN) {
  //   dataHours = "0";
  // }
  if (dataMinutes == '' || dataMinutes == null || dataMinutes == NaN) {
    dataMinutes = "0";
  }
  if (dataSeconds == '' || dataSeconds == null || dataSeconds == NaN) {
    dataSeconds = "0";
  }

  // let hoursSpan = document.createElement('span'),
  let minutesSpan = document.createElement('span'),
  secondsSpan = document.createElement('span'),
  separator1 = document.createElement('span'),
  separator2 = document.createElement('span'),
  separatorValue = ":",
  max = 59,
  s = parseInt(dataSeconds) > max ? max : parseInt(dataSeconds),
  m = parseInt(dataMinutes) > max ? max : parseInt(dataMinutes);
  // h = parseInt(dataHours);

  secondsSpan.classList.add('time');
  minutesSpan.classList.add('time');
  // hoursSpan.classList.add('time');
  separator1.classList.add('separator');
  separator1.textContent = separatorValue;
  separator2.classList.add('separator');
  separator2.textContent = separatorValue;

  let checkValue = (value)=>{
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  // hoursSpan.textContent = checkValue(dataHours);
  minutesSpan.textContent = checkValue(dataMinutes);
  secondsSpan.textContent = checkValue(dataSeconds);

  let timer = (sv,mv,hv) => {
    s = parseInt(sv);
    m = parseInt(mv);
    // h = parseInt(hv);

        if (s > 0) {
          return s -= 1;
        } else {
            s = max;
        if (m > 0) {
          return m -= 1;
        } else {
            m = max;
        // if (h > 0) {
        //   return h -= 1;
        // }
      }
    }
  }

  let finished = () => {
    max = 0;
    let timerEnd = container.getAttribute(timerOnEndMsg);
    container.setAttribute(timerOnEndMsg, 'true');

    if (timerEnd == '' || timerEnd == null) {
        // container.textContent = "timer-end";

        console.log('end')
        console.log(gsap)
        //  Stop time background gsap
        gsap.killTweensOf(timerBg);

        // Fade timer half way
        gsap.to(container, {
          duration: 0.6,
          ease: "power1.Out",
          alpha: 0.5,
          onComplete: () => {
            clearInterval(counter);
          }
        })
        // Fade background out
        gsap.to(timerBg, {
          duration: 0.6,
          ease: "power1.Out",
          alpha: 0,
        })
      } else {
        container.textContent = timerEnd;
      }
    }

    let counter = setInterval(()=>{

    // if (h == 0 && m == 0 && s == 0) {
    if (m == 0 && s == 0) {
      clearInterval(counter, finished());
    }

    if (s >= 0) {
      // timer(s,m,h);
      timer(s,m);
      // hoursSpan.textContent   = checkValue(h);
      minutesSpan.textContent = checkValue(m);
      secondsSpan.textContent = checkValue(s);
    }
  }, oneSec);

  // let children = [hoursSpan, separator1, minutesSpan, separator2, secondsSpan];
  let children = [minutesSpan, separator2, secondsSpan];

  // for (child of children) {
  //   container.appendChild(child);
  // }

  // Updated Count Down
  // container.appendChild(hoursSpan)
  // container.appendChild(separator1)
  container.appendChild(minutesSpan)
  container.appendChild(separator2)
  container.appendChild(secondsSpan)

}
export default CountDownTimer;



// WEBPACK FOOTER //
// ./scripts/components/CountDownTimer.js